/**
 * @file 混入 - 返回
 * @author hardylin <hardylin@tencent.com>
 */

// import { reportToDMP } from './../requests/report.js';

export default {
    methods: {
        igBack() {
            if (history.length < 2 || sessionStorage.igFirstRoute == this.$route.path) {
                this.igClose()
            } else {

                // 微社区场景内返回
                this.$router.back()
            }
        },

        /**
         * 关闭微社区
         */
        igClose() {
            const self = this

            // DMP离开上报容错
            const timer = setTimeout(closeWebview, 300)

            // DMP离开上报
            this.$dmp.report({
                action: 'leave',
                staytime: new Date() - window.timeVisit,
                path: window.path_list.join(',')
            }).then(() => {
                clearTimeout(timer)
                closeWebview()
            })

            function closeWebview(){
                switch (sessionStorage.igBrowser) {
                    case 'tiem':
                        window.customBrowserInterface && window.customBrowserInterface.closeWebview()
                        break
                    case 'msdk':
                        if(sessionStorage.tokenParams.indexOf('itopencodeparam=') > -1){
                            window.msdkCall('{"MsdkMethod":"closeWebView"}');
                        }else{
                            window.msdkCloseWebview && window.msdkCloseWebview();
                        }
                        break
                    default:
                        self.$router.back()
                        break
                }
            }
        }
    }
}
